import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/error.entity";
import QAResponseQuestionEntity from "../../../domain/entities/qa_response_question.entity";
import QAResultEntity from "../../../domain/entities/qa_result.entity";
import SearchResultEntity from "../../../domain/entities/search_result.entity";
import QAResumeEntity from "../../../domain/entities/qa_resume.entity";
import HumanAgentEntity from "../../../domain/entities/human_agent.entity";
import uploadAudioForTranscriptionApiImpl from "./api/upload_audio_for_transcription.api.impl";
import getAudioResultsApiImpl from "./api/get_audio_results.api.impl";
import QAResumeRepository from "../../../domain/repositories/qa_resume.repository";
import downloadCsvJobsApiImpl from "./api/download_csv_jobs.api.impl";
import searchCallsApiImpl from "./api/search_calls.api.impl";
import updateResponseApiImpl from "./api/update_response.api.impl";

@injectable()
class QAResumeRepositoryImpl implements QAResumeRepository {
    uploadAudioForTranscription = async (_: { audio: File, humanAgentId: string, iaAgentId: string, onCallBack?: (progress: number, message: string) => void }): Promise<Either<ErrorEntity, string>> => uploadAudioForTranscriptionApiImpl(_);
    getAudioResults = async (_: {
        jobId: string, onCallBack?: (progress: number, message: string) => void,
        humanAgent?: HumanAgentEntity,
    }): Promise<Either<ErrorEntity, QAResultEntity>> => getAudioResultsApiImpl(_);
    updateResponseQuestion = (response: QAResponseQuestionEntity, jobId: string): Promise<Either<ErrorEntity, QAResponseQuestionEntity>> => updateResponseApiImpl(response, jobId);
    search = async (_: {
        query?: string;
        humanAgentId?: string;
        page: number;
        itemsPerPage: number;
        from?: Date;
        to?: Date;
        call_state?: string;
        sentiment?: string;
        audio_name?: string;
        human_agent_name?: string;
        human_agent_id?: string;
    }): Promise<Either<ErrorEntity, SearchResultEntity<QAResumeEntity>>> => {
        return searchCallsApiImpl({
            page_number: _.page,
            page_size: _.itemsPerPage,
            start_date: _?.from?.toISOString().split("T")[0],
            end_date: _?.to?.toISOString().split("T")[0],
            call_state: _.call_state,
            sentiment: _.sentiment,
            audio_name: _.audio_name,
            human_agent_name: _.human_agent_name,
            human_agent_id: _.humanAgentId || _.human_agent_id,
        });
    };
    
      
    downloadAll = (_: { query?: string; humanAgentId?: string; from?: Date, to?: Date }): Promise<Either<ErrorEntity, void>> => downloadCsvJobsApiImpl(_);
}

export default QAResumeRepositoryImpl;